import styled from 'styled-components';

const TrainingWrapper = styled.div`
  height: 100%;
`;

export { TrainingWrapper };
